/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusCheckStammdatenNamesDto } from '../../models/lexplus-check-stammdaten-names-dto';
import { LexplusStammdatenTyp } from '../../models/lexplus-stammdaten-typ';
import { LexplusSuccessDto } from '../../models/lexplus-success-dto';

export interface StammdatenControllerNameExistsV1$Params {
  typ: LexplusStammdatenTyp;
      body: LexplusCheckStammdatenNamesDto
}

export function stammdatenControllerNameExistsV1(http: HttpClient, rootUrl: string, params: StammdatenControllerNameExistsV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusSuccessDto>> {
  const rb = new RequestBuilder(rootUrl, stammdatenControllerNameExistsV1.PATH, 'post');
  if (params) {
    rb.path('typ', params.typ, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusSuccessDto>;
    })
  );
}

stammdatenControllerNameExistsV1.PATH = '/v1/stammdaten/{typ}/name-exists';
